// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'globe';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 17.438A8.438 8.438 0 1 0 9 .561a8.438 8.438 0 0 0 0 16.875z' />
    <path d='M7.41 17.288c-1.177-1.65-1.972-4.748-1.972-8.25S6.232 2.363 7.41.75m3.18 16.538c1.177-1.65 1.972-4.748 1.972-8.25S11.768 2.363 10.59.75M.563 9h16.875M1.537 12.938h14.925M1.537 5.063h14.925' />
  </g>
);

export const viewBox = '0 0 18 18';
